module.exports = {
	"notification.message": "Wix.com では、サービスをより快適にご利用いただけるようCookieを使用しています。",
	"notification.got.it": "閉じる",
	"notification.more.info": "続きを読む"
};


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_ja.json
// module id = 44
// module chunks = 0